import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { Comparable, UnitMix } from '../../models/comparables.type';
import { buildComparableColumnDefs, unitMixDetailCols } from '../../shared/utils/comparable-grid.util';
import { SectionService } from '../../shared/services/section.service';
import { ComparablesService } from '../../shared/services/comparables.service';
import { ColDef, GridApi, GridOptions, LicenseManager, ModuleRegistry, SideBarDef } from 'ag-grid-enterprise';
import { AgGridAngular } from 'ag-grid-angular';
import * as XLSX from 'xlsx';
import { AllEnterpriseModule } from 'ag-grid-enterprise';

ModuleRegistry.registerModules([AllEnterpriseModule]);
@Component({
  selector: 'app-comparable-rents',
  standalone: true,
  imports: [CommonModule, AgGridAngular],
  templateUrl: './comparable-rents.component.html',
  styleUrl: './comparable-rents.component.scss'
})
export class ComparableRentsComponent {
  rows$: Observable<Comparable[]> = this.comparablesSvc.rent$;
  columnDefs = buildComparableColumnDefs('Rent');

  constructor(private sectionService: SectionService, private comparablesSvc: ComparablesService) {
    LicenseManager.setLicenseKey("Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-078719}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Cushman_&_Wakefield_Global,_Inc}_is_granted_a_{Multiple_Applications}_Developer_License_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Charts_and_AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{18_June_2026}____[v3]_[0102]_MTc4MTczNzIwMDAwMA==3d83d461ffd91d4aa36e813251f26c82");
  }
  ngOnInit(): void {
    this.sectionService.setSelectedSubSection('Comparables');
  }

  defaultColDef: ColDef = {
    filter: 'agTextColumnFilter',
    sortable: true,
    resizable: true,
    floatingFilter: true,
    minWidth: 120,
  };

  sidebar: SideBarDef = {
      toolPanels: [
        'columns',
        'filters',
      ]
    };

  masterDetail = true;
  detailRowAutoHeight = true;

  // Show detail only when we have unit mixes
  isRowMaster = (dataItem: Comparable) =>
    dataItem?.snapshot?.kind === 'Rent' && (dataItem?.snapshot?.rent?.unitMixes?.length ?? 0) > 0;


  detailCellRendererParams = {
    detailGridOptions: {
      columnDefs: unitMixDetailCols,
      defaultColDef: this.defaultColDef,
      // Optionally enable mini filter on detail grid too:
      sideBar: this.sidebar,
    } as GridOptions<UnitMix>,
    getDetailRowData: (params: any) => {
      const mixes = params.data?.snapshot?.rent?.unitMixes ?? [];
      params.successCallback(mixes);
    },
  };

  private api!: GridApi<Comparable>;

  onGridReady(params: any) {
    this.api = params.api;
    params.api.sizeColumnsToFit();
  }

  autoSize() {
    const all = this.api.getColumnDefs()?.map(c => (c as ColDef).field || (c as any).colId).filter(Boolean) as string[];
    this.api.autoSizeColumns(all, false);
  }

  exportCsv() {
    this.api.exportDataAsCsv({
      fileName: 'rent-comparables.csv',
      processCellCallback: p => p.value ?? '',
    });
  }

  exportToXlsx() {
    const csv = this.api.getDataAsCsv();
    const workbook = XLSX.read(csv, { type: 'string' });
    XLSX.writeFile(workbook, 'rent-comparables.xlsx');
  } 
}
